import { render, staticRenderFns } from "./01_ap_medios_transporte.vue?vue&type=template&id=01983f0b&scoped=true&"
import script from "./01_ap_medios_transporte.vue?vue&type=script&lang=js&"
export * from "./01_ap_medios_transporte.vue?vue&type=script&lang=js&"
import style0 from "./01_ap_medios_transporte.vue?vue&type=style&index=0&id=01983f0b&scoped=true&lang=css&"
import style1 from "./01_ap_medios_transporte.vue?vue&type=style&index=1&id=01983f0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01983f0b",
  null
  
)

export default component.exports